import React from "react";
import LightTheme from "../theme/LightTheme";

const GradientLine = () => (
  <div>
    <style jsx>{`
      div {
        width: 100%;
        height: 1px;
        background: ${LightTheme.gradientBackground};
      }
    `}</style>
  </div>
);

export default GradientLine;
